import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";


export const ChatWithElliotSlicer = createSlice({
  name: "ChatWithElliotSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    ChatWithElliot: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successChatWithElliot: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureChatWithElliot: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearChatWithElliotStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ChatWithElliot,
  successChatWithElliot,
  failureChatWithElliot,
  clearChatWithElliotStatus,
} = ChatWithElliotSlicer.actions;

export default ChatWithElliotSlicer.reducer;
